import { IActionButtonCommonProps } from '../../typings/DocumentViewer/actionButtonCommonProps';
import ActionButton from './actionButton';
import { Icons } from 'copyright-clearance-center-common-ui';

interface IPublisherSiteButtonBase {
	publisherSite?: string;
}

const PublisherSiteButton: React.FunctionComponent<IPublisherSiteButtonBase & IActionButtonCommonProps> = props => {
	const handler = () => {
		window.open(props.publisherSite, '_blank');
	};

	return (
		<ActionButton
			label={localize('Publisher site')}
			handler={handler}
			icon={Icons.OpenInNewTabIcon}
			isPrimary={props.isPrimary}
			testId="publisher-site-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default PublisherSiteButton;
